/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetAccountSettingsItem,
    GetAccountSettingsItemFromJSON,
    GetAccountSettingsItemFromJSONTyped,
    GetAccountSettingsItemToJSON,
} from './GetAccountSettingsItem';
import {
    GetAccountSettingsResponseAllOf,
    GetAccountSettingsResponseAllOfFromJSON,
    GetAccountSettingsResponseAllOfFromJSONTyped,
    GetAccountSettingsResponseAllOfToJSON,
} from './GetAccountSettingsResponseAllOf';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 
 * @export
 * @interface GetAccountSettingsResponse
 */
export interface GetAccountSettingsResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetAccountSettingsResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetAccountSettingsResponse
     */
    message: string;
    /**
     * 
     * @type {GetAccountSettingsItem}
     * @memberof GetAccountSettingsResponse
     */
    data: GetAccountSettingsItem;
}

export function GetAccountSettingsResponseFromJSON(json: any): GetAccountSettingsResponse {
    return GetAccountSettingsResponseFromJSONTyped(json, false);
}

export function GetAccountSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountSettingsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': GetAccountSettingsItemFromJSON(json['data']),
    };
}

export function GetAccountSettingsResponseToJSON(value?: GetAccountSettingsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': GetAccountSettingsItemToJSON(value.data),
    };
}

